import { render } from "./BookHouse.vue?vue&type=template&id=5411e60d"
import script from "./BookHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./BookHouse.vue?vue&type=script&setup=true&lang=js"

import "./BookHouse.vue?vue&type=style&index=0&id=5411e60d&lang=css"

import exportComponent from "../../../../../client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"views/order/assets/components/bookHoouse/BookHouse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5411e60d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5411e60d', __exports__)) {
    api.reload('5411e60d', __exports__)
  }
  
  module.hot.accept("./BookHouse.vue?vue&type=template&id=5411e60d", () => {
    api.rerender('5411e60d', render)
  })

}


export default __exports__